import { useTranslation } from "react-i18next";

import Modal from "src/components-v2/Modal";
import Table from "src/components-v2/Table";
import Label from "src/components-v2/Label";
import TableContainer from "src/components/TableContainer";
import TableHeader from "src/components/TableHeader";

import { DEPOSIT_DETAIL_HEADERS } from "src/consts/headers";
import { delimiter } from "src/helpers/number";
import { useBankName } from "src/hooks/bank";
import { useTableHeaders } from "src/hooks/table";

type DataDeposit = {
  data: {
    bank_name: string;
    beneficiary_name: string;
    beneficiary_bank: string;
    beneficiary_name_bank: string;
    account_number: string;
    amount: number;
    is_split_transaction: boolean;
    fee: number;
  }[];
  charged_fee_by_beneficiary?: boolean;
};

type DepositDetailModalProps = {
  /**
   * Set data to be shown
   */
  data: DataDeposit;

  /**
   * Set show or hide modal
   */
  show: boolean;

  /**
   * Modal toggle function
   */
  toggle: (_arg: boolean) => void;

  /**
   * if from International transfer
   */
  isInternationalTransfer: boolean;
};

function DepositDetailModal(props: DepositDetailModalProps) {
  const { data, show, toggle, isInternationalTransfer } = props;
  const { t } = useTranslation("transaction");
  const { getBankName } = useBankName();
  const tableHeaders = useTableHeaders(DEPOSIT_DETAIL_HEADERS, "transaction");

  return (
    <Modal title={t("summary.modal.title")} size="large" show={show} onClose={() => toggle(false)} closeOnOverlay>
      <TableContainer>
        <Table zebra>
          <TableHeader headers={tableHeaders} />
          <tbody>
            {data.data?.map((item, index: number) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{isInternationalTransfer ? item.bank_name : getBankName(item.beneficiary_bank)}</td>
                <td>{isInternationalTransfer ? item.beneficiary_name || "" : item.beneficiary_name_bank}</td>
                <td>{item.account_number}</td>
                <td>
                  {data?.charged_fee_by_beneficiary ? delimiter(item.amount - item.fee) : delimiter(item.amount)}
                  {item.is_split_transaction && (
                    <Label color="blue" className="u-ml-2">
                      SPLIT
                    </Label>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    </Modal>
  );
}

export default DepositDetailModal;
